import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, OnDestroy, OnInit, Type, ViewChild, HostListener } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { DialogConfig } from '../dialog-config';
import { DialogRef } from '../dialog-ref';
import { InsertionDirective } from '../insertion.directive';
import { DialogService } from '../dialog.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements AfterViewInit, OnDestroy {
  componentRef: ComponentRef<any>;
  @ViewChild(InsertionDirective)
  insertionPoint: InsertionDirective;
  private readonly _onClose = new Subject<any>();
  public onClose = this._onClose.asObservable();
  public drawerMinimized = false;
  comparePlansSubscription: Subscription;
  public CompareBack: boolean = false;
  childComponentType: Type<any>;

  @HostListener('window:resize', ['$event'])
  checkPos() {
    document.getElementById('dialog').style.left = this.dialog.pos[0].toString() + 'px';
    document.getElementById('dialog').style.top = this.dialog.pos[1].toString() + 'px';
  }

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
    public config: DialogConfig,
    private cd: ChangeDetectorRef,
    private dialogRef: DialogRef,
    private dialog: DialogService) { }

  ngAfterViewInit() {
    console.log(this.config);
    this.checkPos();
    this.loadChildComponent(this.childComponentType);
    this.cd.detectChanges();

  }

  onOverlayClicked(evt: MouseEvent) {
    if (this.config.closeOnOutsideClick || this.config.closeOnOutsideClick === undefined) {
      this.dialogRef.close();
    }
  }

  onDialogClicked(evt: MouseEvent) {
    evt.stopPropagation();
  }

  loadChildComponent(componentType: Type<any>) {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);

    let viewContainerRef = this.insertionPoint.viewContainerRef;
    viewContainerRef.clear();

    this.componentRef = viewContainerRef.createComponent(componentFactory);
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  close() {
    this._onClose.next();
  }
}
